import { createContext } from 'react'

export interface AuthUser {
  /** Cognito sub claim — primary user identity */
  id: string
  /** Email address from the ID token */
  email: string
  /** True when sign-in came from Google (federated) rather than Cognito directly */
  isFederated: boolean
  /** Cognito groups the user belongs to (e.g. `platform-admin`). Empty array
   *  when the claim is missing — never null, so gates can `.includes()` safely. */
  groups: readonly string[]
}

export type AuthStatus = 'loading' | 'unauthenticated' | 'authenticated' | 'unconfigured'

export interface AuthContextValue {
  status: AuthStatus
  user: AuthUser | null
  /** Refresh the cached user from the current Cognito session */
  refresh: () => Promise<void>
  /** Sign out and clear local session */
  signOut: () => Promise<void>
}

export const AuthContext = createContext<AuthContextValue | null>(null)
